var map = {
	"./avatar1.png": 3422,
	"./avatar2.png": 861,
	"./avatar3.png": 9279,
	"./avatar4.png": 1786,
	"./avatar5.png": 9992,
	"./avatar6.png": 5826,
	"./avatar7.png": 1798,
	"./avatar8.png": 174
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3516;